export class SplashScreenManager {
  static isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches ||
           window.navigator.standalone ||
           document.referrer.includes('android-app://');
  }

  static isPWALaunch() {
    return this.isStandalone() && !sessionStorage.getItem('pwa_session_active');
  }

  static markPWASessionActive() {
    sessionStorage.setItem('pwa_session_active', 'true');
  }

  static shouldShowSplash() {
    return this.isPWALaunch() || !sessionStorage.getItem('splash_shown_this_session');
  }

  static markSplashShown() {
    sessionStorage.setItem('splash_shown_this_session', 'true');
    if (this.isStandalone()) {
      this.markPWASessionActive();
    }
  }

  static preloadCriticalResources() {
    const criticalImages = [
      '/icons/terriqon/terriqon-light.svg',
      '/favicon.png',
      '/icons/terriqon/terriqon-dark.svg'
    ];

    criticalImages.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }

  static hideBrowserSplash() {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', '#005A9C');
    }
  }

  static setupViewportForSplash() {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      );
    }
  }
}

if (typeof window !== 'undefined') {
  SplashScreenManager.hideBrowserSplash();
  SplashScreenManager.setupViewportForSplash();
  SplashScreenManager.preloadCriticalResources();
}